import React from 'react';
import Icon from '../icon/Icon';
import WhiteContainer from './WhiteContainer';
import TextDivider from '../text/TextDivider';
import Loading from '../loading/Loading';
var ResultContainer = function(param) {
    var icon = param.icon, firstHeader = param.firstHeader, resultStatus = param.resultStatus, isLoading = param.isLoading, header = param.header, extraInfo = param.extraInfo;
    return /*#__PURE__*/ React.createElement(WhiteContainer, {
        className: "ResultContainer"
    }, !isLoading ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
        icon: icon
    }), /*#__PURE__*/ React.createElement("h3", {
        className: "pt-3"
    }, resultStatus), /*#__PURE__*/ React.createElement(TextDivider, {
        isComplete: true,
        isSecondary: true
    }), /*#__PURE__*/ React.createElement("p", {
        className: "mb-2 lightText"
    }, /*#__PURE__*/ React.createElement("small", null, header)), /*#__PURE__*/ React.createElement("h3", {
        className: "pb-3 text-center"
    }, firstHeader), extraInfo) : /*#__PURE__*/ React.createElement(Loading, null));
};
export default ResultContainer;
